module.exports = __webpack_public_path__ + "img/well_jiaoliu_bg.271707a2.png";